import { Tooltip } from 'antd'
import { useAppDispatch } from '@/hooks'
import {
  setAnalysisImageId,
  setAnalysisWorkId,
  setSelectedPage
} from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import {
  setCompareImageId,
  setCompareWorkId
} from '@/features/SetCompareImageInfo/setCompareImageInfo'
import { setShowType } from '@/features/SetCompareInfo/setCompareInfo'
import { SRC_URL } from '@/server'

const SimilarityOrder = (props) => {
  const dispatch = useAppDispatch()
  const chuanyiData = props.similarImgsInfo
  return (
    <div className='chuanyi-similarityOrder'>
      {chuanyiData.map((eachImg) => {
        return (
          <div className='chuanyi-similarityOrder-eachImage' key={eachImg?.imgSrc}>
            <Tooltip
              overlayStyle={{ maxWidth: 1920 }}
              title={
                <div>
                  <button
                    className='chuanyi-compareImgButton'
                    onClick={() => {
                      dispatch(setAnalysisImageId(eachImg.imageId))
                      dispatch(setAnalysisWorkId(eachImg.workId))
                    }}
                  >
                    画作分析
                  </button>
                  <button
                    className='chuanyi-compareImgButton'
                    onClick={() => {
                      dispatch(setCompareImageId(eachImg.imageId))
                      dispatch(setCompareWorkId(eachImg.workId))
                      dispatch(setSelectedPage(2))
                      dispatch(setShowType(2))
                    }}
                  >
                    画作对比
                  </button>
                </div>
              }
              trigger='click'
            >
              <img
                className='chuanyi-similarityOrder-eachImage-showImg'
                src={eachImg?.imgSrc ? SRC_URL + eachImg.imgSrc : ''}
                alt=''
              ></img>
            </Tooltip>
            <div className='chuanyi-similarityOrder-eachImage-imgInfo'>
              <div className='chuanyi-similarityOrder-eachImage-imgInfo-title'>
                {eachImg.title + ' ' + eachImg?.similarity + '%'}
              </div>
              <div className='chuanyi-similarityOrder-eachImage-imgInfo-author'>
                {eachImg.dynasty + ' ' + eachImg.author}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default SimilarityOrder
